import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { SingleSparkRunFavouriteResponse } from 'types/SparkRunFavourite';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { Cookies } from 'react-cookie';

type mutationVariables = {
  email: string | undefined;
  password: string;
  confirmPassword: string;
};

export function useConfirmPassword() {
  const cookies = new Cookies();
  const _token = cookies.get('userToken');
  const forgetPassword = ({
    email,
    password,
    confirmPassword,
  }: mutationVariables) => {
    const body = {
      token: _token,
      email,
      password,
      confirmPassword,
    };

    const url = generateURL(SPARK_RESOURCE_TYPES.CHANGE_PASSWORD);
    return fetchWrapper<SingleSparkRunFavouriteResponse>({
      url: url,
      method: 'Post',
      body: body,
    });
  };

  return useMutation('forgetPassword', forgetPassword, {
    onSuccess: (data: any) => {
      toastr.success(data.message);
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Error sending email: ${error.message}`);
      }
    },
  });
}
